import { useState, useEffect } from 'react';
import { additionalContentService } from '@/services/additionalContentService';
import { AdditionalContent } from '@/types/additionalContent';
import { useProfileStore } from '@/store/useProfileStore';

interface UseAdditionalContentOptions {
  page: string;
  slot: string;
  enabled?: boolean; // Optional flag to control when to fetch
}

export function useAdditionalContent({ page, slot, enabled = true }: UseAdditionalContentOptions) {
  const profile = useProfileStore((state) => state.activeProfile);
  const [content, setContent] = useState<AdditionalContent[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!enabled) {
      setLoading(false);
      return;
    }

    const fetchContent = async () => {
      // Wait for profile to be available (ensures authentication is ready)
      if (!profile?.id) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const data = await additionalContentService.searchAdditionalContent({ page, slot });
        
        // Sort by order field (ascending)
        const sortedData = [...data].sort((a, b) => (a.order || 0) - (b.order || 0));
        
        setContent(sortedData);
      } catch (err) {
        // Error modal presented by API
        setContent([]);
      } finally {
        setLoading(false);
      }
    };

    fetchContent();
  }, [page, slot, profile?.id, enabled]);

  return { content, loading };
}

